export default "__VITE_ASSET__d1ZUpXQS__"